import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const availableClaims = [
    { name: 'events', value: 'events', displayName: 'Events' },
    { name: 'happenings', value: 'happenings', displayName: 'Happenings' },
    { name: 'hrbenefits', value: 'hrbenefits', displayName: 'HR & Benefits' },
    { name: 'employees', value: 'employees', displayName: 'Employees' },
    { name: 'departments', value: 'departments', displayName: 'Departments' },
    { name: 'marketplace', value: 'marketplace', displayName: 'Market Place' },
    { name: 'contest', value: 'contest', displayName: 'Contest' },
    { name: 'positionsqualifications', value: 'positionsqualifications', displayName: 'Positions & Qualifications' },
    { name: 'interests', value: 'interests', displayName: 'Interests' },
    { name: 'installedprojects', value: 'installedprojects', displayName: 'Installed Projects' },
    { name: 'financials', value: 'financials', displayName: 'Financials' },
    { name: 'textalerts', value: 'textalerts', displayName: 'Text Alerts' },
    { name: 'documentlibrary', value: 'documentlibrary', displayName: 'Document Library' },
    { name: 'ggobresources', value: 'ggobresources', displayName: 'GGOB Resources' },
    { name: 'companyshopmonitors', value: 'companyshopmonitors', displayName: 'Company Shop Monitor IPs' },
    { name: 'adminusers', value: 'adminusers', displayName: 'Admin Users' },
];

export default function ClaimsSelector({ claims = [], onChange }) {
    const [selectedClaims, setSelectedClaims] = useState([]);

    const handleClaimChange = (isChecked, value) => {
        let updatedClaims;
        if (isChecked) {
            updatedClaims = [...selectedClaims, value];
        } else {
            updatedClaims = selectedClaims.filter(claim => claim !== value);
        }
        setSelectedClaims(updatedClaims);
        onChange && onChange(updatedClaims);
    };

    useEffect(() => {
        setSelectedClaims(claims);
    }, [claims]);

    return (
        <div className="claims-selector">
            {availableClaims.map((claim, idx) => {
                const isChecked = selectedClaims.includes(claim.value);
                return (
                    <label key={idx} className="admin-inline-label" htmlFor={claim.name + "_access"}>
                        <input
                            className="admin-inline-checkbox"
                            id={claim.name + "_access"}
                            type="checkbox"
                            value={claim.value}
                            checked={isChecked}
                            onChange={(e) => handleClaimChange(e.target.checked, e.target.value)}
                        />
                        <span className="admin-inline-label-text">{claim.displayName}</span>
                    </label>
                );
            })}
        </div>
    );
}

ClaimsSelector.propTypes = {
    claims: PropTypes.array,
    onChange: PropTypes.func,
};